import Validator from 'services/data-validator'

const passwordRequestValidator = values => (
  new Validator(values, {
    email: ['isRequired', 'isEmail']
  }).getErrors()
)

export default passwordRequestValidator
